import React from 'react';
import { Link } from 'react-router';

class Button extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return this.props.href ? (
      <a
        target={this.props.target}
        href={this.props.disabled ? 'javascript:void(0);' : this.props.href}
        className={`button button-${this.props.type}  ${this.props.disabled
          ? 'button-disabled'
          : ''}`}
      >
        {this.props.children}
      </a>
    ) : this.props.to ? (
      <Link
        to={this.props.disabled ? null : this.props.to}
        className={`button button-${this.props.type} ${this.props.disabled
          ? 'button-disabled'
          : ''}`}
      >
        {this.props.children}
      </Link>
    ) : (
      <button
        type={this.props.type == 'primary' ? 'submit' : 'button'}
        role="button"
        onClick={this.props.disabled ? null : this.props.onClick}
        className={`button button-${this.props.type} ${this.props.disabled
          ? 'button-disabled'
          : ''}`}
      >
        {this.props.children}
      </button>
    );
  }
}

Button.propTypes = {
  children: React.PropTypes.node,
  onClick: React.PropTypes.func,
  href: React.PropTypes.string,
  to: React.PropTypes.string,
  target: React.PropTypes.string,
  disabled: React.PropTypes.bool,
  type: React.PropTypes.oneOf(['default', 'primary', 'danger', 'default-green'])
};

Button.defaultProps = {
  disabled: false,
  children: null,
  type: 'default',
  target: '_blank'
};

export default Button;



// WEBPACK FOOTER //
// ./src/js/components/inputs/Button.js